export interface IInventoryItemType {
  itemTypeId: string;
  itemTypeName: string;
  isActive: string;
}
